<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-3 col-sm-6 mt-sm-0">
        <card :title="$t('totalStudents')" :value="indicators['total_students']" percentage=""
          iconClass="ni ni-single-02" :iconBackground="stats.iconBackground" directionReverse>
        </card>
      </div>
      <div class="col-lg-3 col-sm-6 mt-sm-0">
        <card :title="$t('maleStudents')" :value="indicators['total_students_m']" percentage=""
          iconClass="ni ni-single-02" :iconBackground="stats.iconBackground" directionReverse>
        </card>
      </div>
      <div class="col-lg-3 col-sm-6 mt-sm-0">
        <card :title="$t('femaleStudents')" :value="indicators['total_students_f']" percentage=""
          iconClass="ni ni-single-02" :iconBackground="stats.iconBackground" directionReverse>
        </card>
      </div>
      <div class="col-lg-3 col-sm-6 mt-sm-0">
        <card :title="$t('totalTrainings')" :value="indicators['total_trainings']" percentage=""
          iconClass="ni ni-single-02" :iconBackground="stats.iconBackground" directionReverse>
        </card>
      </div>
      <div class="col-lg-3 col-sm-6 mt-sm-0">
        <card :title="$t('onTimeStudents')" :value="indicators['on_time_students']" percentage=""
          iconClass="ni ni-check-bold" :iconBackground="'bg-gradient-success'" directionReverse>
        </card>
      </div>
      <div class="col-lg-3 col-sm-6 mt-sm-0">
        <card :title="$t('lateStudents')" :value="indicators['late_students']" percentage=""
          iconClass="ni ni-bell-55" :iconBackground="'bg-gradient-danger'" directionReverse>
        </card>
      </div>
      <!-- Card de Aniversariantes -->
      <div class="col-lg-6 col-sm-12 mt-sm-0">
        <div class="card mb-4" style="position: relative;">
          <div class="card-body p-3">
            <div class="d-flex flex-row-reverse justify-content-between">
              <div>
                <div class="text-center shadow icon icon-shape border-radius-md bg-gradient-success">
                  <i class="ni ni-calendar-grid-58 text-lg opacity-10" aria-hidden="true"></i>
                </div>
              </div>
              <div>
                <div class="numbers">
                  <p class="mb-0 text-sm text-capitalize font-weight-bold">🎂 Aniversariantes</p>
                  <h5 class="mb-0 font-weight-bolder">
                    <template v-if="aniversariantesDia.length > 0">
                      {{ aniversariantesDia[0].nome_completo }}
                    </template>
                    <template v-else-if="aniversariantesMes.length > 0">
                      {{ aniversariantesMes.length }}
                    </template>
                    <template v-else>
                      0
                    </template>
                    <span class="text-sm font-weight-bolder">
                      {{ aniversariantesDia.length > 0 ? '🎉 Hoje' : ' no mês' }}
                    </span>
                  </h5>
                </div>
              </div>
            </div>
            <!-- Seta posicionada absolutamente no fundo do card -->
            <div v-if="aniversariantesMes.length > 0"
              style="position: absolute; bottom: 5px; left: 50%; transform: translateX(-50%); cursor: pointer;"
              @click="toggleAniversariantes">
              <i :class="mostrarTodosAniversariantes ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"
                style="font-size: 0.6rem; color: #6c757d;"></i>
            </div>
          </div>
          <!-- Lista expansível que cresce o card -->
          <div v-if="mostrarTodosAniversariantes && aniversariantesMes.length > 0" class="card-body pt-0 px-3 pb-2"
            style="animation: slideDown 0.3s ease-out;">
            <div class="border-top pt-2">
              <div v-for="aluno in aniversariantesMes" :key="aluno.id" class="py-1 border-bottom"
                style="font-size: 0.75rem;">
                <div class="d-flex justify-content-between align-items-center">
                  <span class="text-dark font-weight-bold">{{ aluno.nome_completo }}</span>
                  <span class="text-secondary">{{ aluno.dia_aniversario }}/{{ getMesNumero() }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card pb-5">
          <div class="p-3 pb-0">
            <!-- Botões de alternância melhorados -->
            <div class="row justify-content-center mb-3">
              <div class="btn-group" role="group" aria-label="Dashboard Charts Toggle">
                <button type="button" class="btn btn-outline-primary"
                  :class="{ active: graficoSelecionado === 'evolucao' }" @click="graficoSelecionado = 'evolucao'">
                  {{ $t('evolutionComparison') }}
                </button>
                <button type="button" class="btn btn-outline-primary"
                  :class="{ active: graficoSelecionado === 'grupos' }" @click="graficoSelecionado = 'grupos'">
                  {{ $t('muscleGroups') }}
                </button>
              </div>
            </div>
            <!-- Gráfico de evolução -->
            <div v-if="graficoSelecionado === 'evolucao'">
              <div class="row justify-content-center">
                <div class="col-12 text-center">{{ $t('evolutionComparison') }}</div>
                <div class="col-6">
                  <label class="form-label mt-2 text-center">{{ $t('selectStudent') }}</label>
                  <select class="form-control" name="dashboard-alunos" id="dashboard-alunos" v-model="alunoSelecionado"
                    @change="setStudentManagerEvolucao">
                    <option value="" selected="selected">{{ $t('selectHere') }}</option>
                    <option v-for="(item, index) in alunos" :key="index" :value="item.id">
                      {{ item.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="row">
                <div class="col-12 d-flex justify-content-center align-items-end">
                  <div class="mx-2">
                    <span>
                      <i class="fa fa-arrow-left" @click="voltarData"></i>
                    </span>
                  </div>
                  <div class="mx-2">
                    <label class="form-label mt-2">{{ $t('monthReference') }}</label>
                    <select class="form-control form-control-sm custom-select" v-model="mesSelecionado"
                      @change="getDashboardData">
                      <option v-for="(item, index) in stats.months" :key="index" :value="item.numero">
                        {{ $t(item.mes) }}
                      </option>
                    </select>
                  </div>
                  <div class="mx-2">
                    <label class="form-label mt-2">{{ $t('yearReference') }}</label>
                    <select class="form-control form-control-sm custom-select" v-model="anoSelecionado"
                      @change="getDashboardData">
                      <option value="2023" selected>2023</option>
                      <option value="2024">2024</option>
                      <option value="2025">2025</option>
                      <option value="2026">2026</option>
                      <option value="2027">2027</option>
                      <option value="2028">2028</option>
                      <option value="2029">2029</option>
                      <option value="2030">2030</option>
                    </select>
                  </div>
                  <div class="mx-2">
                    <span>
                      <i class="fa fa-arrow-right" @click="avancarData"></i>
                    </span>
                  </div>
                </div>
              </div>

              <!-- Botões de Relatório -->
              <div v-if="alunoSelecionado" class="row mt-4">
                <div class="col-12 d-flex justify-content-center">
                  <div class="btn-group" role="group">
                    <button class="btn btn-info btn-sm" @click="previewResumo"
                      :disabled="statusEnvioRelatorio === 'enviando' || !resumoAluno" title="Preview do Resumo">
                      <i class="fa fa-eye me-1"></i>
                      Preview Resumo
                    </button>
                    <button class="btn btn-primary btn-sm" @click="enviarRelatorioResumo"
                      :disabled="statusEnvioRelatorio === 'enviando' || !resumoAluno" title="Enviar apenas o Resumo">
                      <i class="fa fa-paper-plane me-1"></i>
                      {{ statusEnvioRelatorio === 'enviando' ? 'Enviando...' : 'Enviar Resumo' }}
                    </button>
                    <button class="btn btn-secondary btn-sm" @click="previewCompleto"
                      :disabled="statusEnvioRelatorio === 'enviando' || !resumoAluno"
                      title="Preview do Relatório Completo (Evolução + Resumo)">
                      <i class="fa fa-eye me-1"></i>
                      Preview Completo
                    </button>
                    <button class="btn btn-success btn-sm" @click="enviarRelatorioCompleto"
                      :disabled="statusEnvioRelatorio === 'enviando' || !resumoAluno"
                      title="Enviar Relatório Completo (Evolução + Resumo)">
                      <i class="fa fa-paper-plane me-1"></i>
                      {{ statusEnvioRelatorio === 'enviando' ? 'Enviando...' : 'Enviar Completo' }}
                    </button>
                  </div>
                </div>
              </div>

              <div id="tabela-comparacao-evolucao" class="row mt-5">
                <div class="col-12 table-responsive">
                  <table class="table table-bordered table-striped">
                    <thead>
                      <tr class="text-center">
                        <th></th>
                        <th colspan="3" class="font-weight-bold">{{ $t('planned') }}</th>
                        <th colspan="3" class="font-weight-bold">{{ $t('realized') }}</th>
                      </tr>
                      <tr>
                        <th></th>
                        <th>{{ $t('month') }}</th>
                        <th>{{ $t('year') }} {{ anoSelecionado }}</th>
                        <th>{{ $t('accumulated') }}</th>
                        <th>{{ $t('month') }}</th>
                        <th>{{ $t('year') }} {{ anoSelecionado }}</th>
                        <th>{{ $t('accumulated') }}</th>
                      </tr>
                    </thead>
                    <tbody v-if="dashboardItemEstimado != null">
                      <tr>
                        <td class="font-weight-bold">{{ $t('totalTrainingTime') }}</td>
                        <td>{{ dashboardItemEstimado['psr_pse']['tempo']['mes'] }}</td>
                        <td>{{ dashboardItemEstimado['psr_pse']['tempo']['ano'] }}</td>
                        <td>{{ dashboardItemEstimado['psr_pse']['tempo']['acumulado'] }}</td>
                        <td>{{ dashboardItem['psr_pse']['tempo']['mes'] }}</td>
                        <td>{{ dashboardItem['psr_pse']['tempo']['ano'] }}</td>
                        <td>{{ dashboardItem['psr_pse']['tempo']['acumulado'] }}</td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold">{{ $t('numberOfTrainingsCompleted') }}</td>
                        <td>{{ dashboardItemEstimado['treinos']['realizados']['mes'] }}</td>
                        <td>{{ dashboardItemEstimado['treinos']['realizados']['ano'] }}</td>
                        <td>{{ dashboardItemEstimado['treinos']['realizados']['acumulado'] }}</td>
                        <td>{{ dashboardItem['treinos']['realizados']['mes'] }}</td>
                        <td>{{ dashboardItem['treinos']['realizados']['ano'] }}</td>
                        <td>{{ dashboardItem['treinos']['realizados']['acumulado'] }}</td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold">{{ $t('numberOfTrainingsNotCompleted') }}</td>
                        <td>{{ dashboardItemEstimado['treinos']['nao_realizados']['mes'] }}</td>
                        <td>{{ dashboardItemEstimado['treinos']['nao_realizados']['ano'] }}</td>
                        <td>{{ dashboardItemEstimado['treinos']['nao_realizados']['acumulado'] }}</td>
                        <td>{{ dashboardItem['treinos']['nao_realizados']['mes'] }}</td>
                        <td>{{ dashboardItem['treinos']['nao_realizados']['ano'] }}</td>
                        <td>{{ dashboardItem['treinos']['nao_realizados']['acumulado'] }}</td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold">{{ $t('totalRepetitions') }}</td>
                        <td>{{ dashboardItemEstimado['dados_treinos']['repeticao']['mes'] }}</td>
                        <td>{{ dashboardItemEstimado['dados_treinos']['repeticao']['ano'] }}</td>
                        <td>
                          {{ dashboardItemEstimado['dados_treinos']['repeticao']['acumulado'] }}
                        </td>
                        <td>{{ dashboardItem['dados_treinos']['repeticao']['mes'] }}</td>
                        <td>{{ dashboardItem['dados_treinos']['repeticao']['ano'] }}</td>
                        <td>{{ dashboardItem['dados_treinos']['repeticao']['acumulado'] }}</td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold">{{ $t('totalSets') }}</td>
                        <td>{{ dashboardItemEstimado['dados_treinos']['serie']['mes'] }}</td>
                        <td>{{ dashboardItemEstimado['dados_treinos']['serie']['ano'] }}</td>
                        <td>{{ dashboardItemEstimado['dados_treinos']['serie']['acumulado'] }}</td>
                        <td>{{ dashboardItem['dados_treinos']['serie']['mes'] }}</td>
                        <td>{{ dashboardItem['dados_treinos']['serie']['ano'] }}</td>
                        <td>{{ dashboardItem['dados_treinos']['serie']['acumulado'] }}</td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold">{{ $t('totalTonage') }}</td>
                        <td>{{ dashboardItemEstimado['dados_treinos']['tonelagem']['mes'] }}</td>
                        <td>{{ dashboardItemEstimado['dados_treinos']['tonelagem']['ano'] }}</td>
                        <td>
                          {{ dashboardItemEstimado['dados_treinos']['tonelagem']['acumulado'] }}
                        </td>
                        <td>{{ dashboardItem['dados_treinos']['tonelagem']['mes'] }}</td>
                        <td>{{ dashboardItem['dados_treinos']['tonelagem']['ano'] }}</td>
                        <td>{{ dashboardItem['dados_treinos']['tonelagem']['acumulado'] }}</td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold">{{ $t('averagePSE') }}</td>
                        <td>{{ dashboardItemEstimado['psr_pse']['pse']['mes'] }}</td>
                        <td>{{ dashboardItemEstimado['psr_pse']['pse']['ano'] }}</td>
                        <td>{{ dashboardItemEstimado['psr_pse']['pse']['acumulado'] }}</td>
                        <td>{{ dashboardItem['psr_pse']['pse']['mes'] }}</td>
                        <td>{{ dashboardItem['psr_pse']['pse']['ano'] }}</td>
                        <td>{{ dashboardItem['psr_pse']['pse']['acumulado'] }}</td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold">{{ $t('averagePSR') }}</td>
                        <td>{{ dashboardItemEstimado['psr_pse']['psr']['mes'] }}</td>
                        <td>{{ dashboardItemEstimado['psr_pse']['psr']['ano'] }}</td>
                        <td>{{ dashboardItemEstimado['psr_pse']['psr']['acumulado'] }}</td>
                        <td>{{ dashboardItem['psr_pse']['psr']['mes'] }}</td>
                        <td>{{ dashboardItem['psr_pse']['psr']['ano'] }}</td>
                        <td>{{ dashboardItem['psr_pse']['psr']['acumulado'] }}</td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold">{{ $t('averageArbitraryAuthority') }}</td>
                        <td colspan="3" class="text-center text-muted font-italic">
                          (Calculado apenas para treinos realizados)
                        </td>
                        <td>{{ dashboardItem['psr_pse']['autoridade']['mes'] }}</td>
                        <td>{{ dashboardItem['psr_pse']['autoridade']['ano'] }}</td>
                        <td>{{ dashboardItem['psr_pse']['autoridade']['acumulado'] }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- Resumo do Mês - Abaixo da tabela de Comparação de Evolução -->
              <div v-if="resumoAluno && alunoSelecionado" class="row mt-5">
                <div class="col-12">
                  <div class="card">
                    <div class="card-body">
                      <!-- Título -->
                      <h4 class="mb-3">
                        📊 Resumo do Mês:
                        <span v-if="mesSelecionado && anoSelecionado" class="month-indicator">
                          {{ getMesNome(mesSelecionado) }}/{{ anoSelecionado }}
                        </span>
                      </h4>

                      <!-- Container completo de gráficos e dados para captura -->
                      <div id="graficos-resumo-completo" class="card card-body mb-3" style="background-color: #ffffff;">
                        <!-- Gráficos lado a lado -->
                        <div class="row mb-3">
                          <div class="col-md-6 col-12 mb-3">
                            <h5 class="mb-3">Resumo do mês</h5>
                            <ResumoMesChart v-if="resumoAluno.detalhes_mes"
                              :executados="resumoAluno.detalhes_mes.executados"
                              :contratados="resumoAluno.detalhes_mes.contratados"
                              :excedentes="resumoAluno.detalhes_mes.excedentes" />
                            <div v-else class="text-center text-muted">Sem dados do mês</div>
                          </div>

                          <div class="col-md-6 col-12 mb-3">
                            <h5 class="mb-3">Gasto calórico do mês</h5>
                            <CaloricMonthChart v-if="resumoAlunoCaloric"
                              :trainingCaloric="resumoAlunoCaloric.training_caloric"
                              :planAccumulated="resumoAlunoCaloric.plan_accumulated" />
                            <div v-else class="text-center text-muted">Sem dados do mês</div>
                          </div>
                        </div>

                        <!-- Tabela de Resumo - MODELO 2x2 -->
                        <div class="row" style="border-top: 2px solid #e9ecef; padding-top: 15px;">
                          <div class="col-12">
                            <h5 class="mb-3 text-center">Resumo Geral</h5>

                            <!-- Primeira linha: Mês e Plano -->
                            <div class="table-responsive mb-3">
                              <table class="table table-bordered table-sm">
                                <thead class="table-light">
                                  <tr>
                                    <th class="text-center font-weight-bold" colspan="2" style="width: 50%;">Resumo do
                                      Mês
                                    </th>
                                    <th class="text-center font-weight-bold" colspan="2" style="width: 50%;">Resumo do
                                      Plano
                                    </th>
                                  </tr>
                                </thead>
                                <tbody class="text-sm">
                                  <tr>
                                    <td style="width: 37.5%;">Treinos previstos no mês</td>
                                    <td class="text-center font-weight-bold" style="width: 12.5%;">
                                      <template
                                        v-if="resumoAluno.detalhes_mes && resumoAluno.detalhes_mes.previstos !== undefined">
                                        {{ resumoAluno.detalhes_mes.previstos }}
                                      </template>
                                      <template v-else>-</template>
                                    </td>
                                    <td style="width: 37.5%;">Treinos previstos no plano atual</td>
                                    <td class="text-center font-weight-bold" style="width: 12.5%;">
                                      {{ resumoAluno.total_trainings || 0 }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style="width: 37.5%;">Aulas contratadas neste mês</td>
                                    <td class="text-center font-weight-bold" style="width: 12.5%;">
                                      <template
                                        v-if="resumoAluno.detalhes_mes && resumoAluno.detalhes_mes.contratados !== undefined">
                                        {{ resumoAluno.detalhes_mes.contratados }}
                                      </template>
                                      <template v-else-if="resumoAluno.aulas_contratadas_mes !== null">
                                        {{ resumoAluno.aulas_contratadas_mes }}
                                      </template>
                                      <template v-else>-</template>
                                    </td>
                                    <td style="width: 37.5%;">Aulas contratadas no plano atual</td>
                                    <td class="text-center font-weight-bold" style="width: 12.5%;">
                                      {{ resumoAluno.total_contratadas_plano || 0 }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Treinos executados</td>
                                    <td class="text-center font-weight-bold">
                                      <template
                                        v-if="resumoAluno.detalhes_mes && resumoAluno.detalhes_mes.executados !== undefined">
                                        {{ resumoAluno.detalhes_mes.executados }}
                                      </template>
                                      <template v-else>-</template>
                                    </td>
                                    <td>Treinos executados</td>
                                    <td class="text-center font-weight-bold">
                                      {{ resumoAluno.total_trainings_executed || 0 }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Treinos não executados</td>
                                    <td class="text-center font-weight-bold">
                                      <template
                                        v-if="resumoAluno.detalhes_mes && resumoAluno.detalhes_mes.nao_executados !== undefined">
                                        {{ resumoAluno.detalhes_mes.nao_executados }}
                                      </template>
                                      <template v-else>-</template>
                                    </td>
                                    <td>Treinos não executados</td>
                                    <td class="text-center font-weight-bold">
                                      {{ resumoAluno.total_trainings_not_executed || 0 }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Treinos incompletos</td>
                                    <td class="text-center font-weight-bold">
                                      <template
                                        v-if="resumoAluno.detalhes_mes && resumoAluno.detalhes_mes.incompletos !== undefined">
                                        {{ resumoAluno.detalhes_mes.incompletos }}
                                      </template>
                                      <template v-else>-</template>
                                    </td>
                                    <td>Treinos incompletos</td>
                                    <td class="text-center font-weight-bold">
                                      {{ resumoAluno.total_trainings_incomplete || 0 }}
                                    </td>
                                  </tr>
                                  <tr class="table-warning">
                                    <td>Treinos excedentes (mês atual)</td>
                                    <td class="text-center font-weight-bold text-danger">
                                      <template
                                        v-if="resumoAluno.detalhes_mes && resumoAluno.detalhes_mes.excedentes !== undefined">
                                        {{ resumoAluno.detalhes_mes.excedentes }}
                                      </template>
                                      <template v-else>-</template>
                                    </td>
                                    <td>Treinos excedentes (plano atual)</td>
                                    <td class="text-center font-weight-bold text-danger">
                                      {{ resumoAluno.total_trainings_excedentes || 0 }}
                                    </td>
                                  </tr>
                                  <tr v-if="resumoAlunoCaloric" class="table-info">
                                    <td>Gasto calórico acumulado neste mês</td>
                                    <td class="text-center font-weight-bold">
                                      {{ resumoAlunoCaloric.training_caloric || 0 }}
                                    </td>
                                    <td>Gasto calórico acumulado no plano atual</td>
                                    <td class="text-center font-weight-bold">
                                      {{ resumoAlunoCaloric.plan_accumulated || 0 }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>PSE médio</td>
                                    <td class="text-center font-weight-bold">
                                      {{ resumoAluno.pse_medio_mes || '-' }}
                                    </td>
                                    <td>PSE médio</td>
                                    <td class="text-center font-weight-bold">
                                      {{ resumoAluno.pse_medio_plano || '-' }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>PSR médio</td>
                                    <td class="text-center font-weight-bold">
                                      {{ resumoAluno.psr_medio_mes || '-' }}
                                    </td>
                                    <td>PSR médio</td>
                                    <td class="text-center font-weight-bold">
                                      {{ resumoAluno.psr_medio_plano || '-' }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>

                            <!-- Segunda linha: Ano e Acumulado Total -->
                            <div class="table-responsive">
                              <table class="table table-bordered table-sm">
                                <thead class="table-light">
                                  <tr>
                                    <th class="text-center font-weight-bold" colspan="2" style="width: 50%;">Resumo do
                                      Ano
                                      ({{ anoSelecionado }})</th>
                                    <th class="text-center font-weight-bold" colspan="2" style="width: 50%;">Resumo
                                      Acumulado Total</th>
                                  </tr>
                                </thead>
                                <tbody class="text-sm">
                                  <tr>
                                    <td style="width: 37.5%;">Aulas contratadas neste ano</td>
                                    <td class="text-center font-weight-bold" style="width: 12.5%;">
                                      {{ resumoAluno.resumo_ano?.total_trainings || 0 }}
                                    </td>
                                    <td style="width: 37.5%;">Aulas contratadas (histórico completo)</td>
                                    <td class="text-center font-weight-bold" style="width: 12.5%;">
                                      {{ resumoAluno.resumo_total?.total_trainings || 0 }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Treinos executados</td>
                                    <td class="text-center font-weight-bold">
                                      {{ resumoAluno.resumo_ano?.total_trainings_executed || 0 }}
                                    </td>
                                    <td>Treinos executados</td>
                                    <td class="text-center font-weight-bold">
                                      {{ resumoAluno.resumo_total?.total_trainings_executed || 0 }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Treinos não executados</td>
                                    <td class="text-center font-weight-bold">
                                      {{ resumoAluno.resumo_ano?.total_trainings_not_executed || 0 }}
                                    </td>
                                    <td>Treinos não executados</td>
                                    <td class="text-center font-weight-bold">
                                      {{ resumoAluno.resumo_total?.total_trainings_not_executed || 0 }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Treinos incompletos</td>
                                    <td class="text-center font-weight-bold">
                                      {{ resumoAluno.resumo_ano?.total_trainings_incomplete || 0 }}
                                    </td>
                                    <td>Treinos incompletos</td>
                                    <td class="text-center font-weight-bold">
                                      {{ resumoAluno.resumo_total?.total_trainings_incomplete || 0 }}
                                    </td>
                                  </tr>
                                  <tr class="table-warning">
                                    <td>Treinos excedentes (ano atual)</td>
                                    <td class="text-center font-weight-bold text-danger">
                                      {{ resumoAluno.resumo_ano?.total_trainings_excedentes || 0 }}
                                    </td>
                                    <td>Treinos excedentes (histórico completo)</td>
                                    <td class="text-center font-weight-bold text-danger">
                                      {{ resumoAluno.resumo_total?.total_trainings_excedentes || 0 }}
                                    </td>
                                  </tr>
                                  <tr v-if="resumoAlunoCaloric" class="table-info">
                                    <td>Gasto calórico acumulado neste ano</td>
                                    <td class="text-center font-weight-bold">
                                      {{ resumoAluno.resumo_ano?.gasto_calorico || 0 }}
                                    </td>
                                    <td>Gasto calórico acumulado (histórico completo)</td>
                                    <td class="text-center font-weight-bold">
                                      {{ resumoAluno.resumo_total?.gasto_calorico || 0 }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>PSE médio</td>
                                    <td class="text-center font-weight-bold">
                                      {{ resumoAluno.resumo_ano?.pse_medio || '-' }}
                                    </td>
                                    <td>PSE médio</td>
                                    <td class="text-center font-weight-bold">
                                      {{ resumoAluno.resumo_total?.pse_medio || '-' }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>PSR médio</td>
                                    <td class="text-center font-weight-bold">
                                      {{ resumoAluno.resumo_ano?.psr_medio || '-' }}
                                    </td>
                                    <td>PSR médio</td>
                                    <td class="text-center font-weight-bold">
                                      {{ resumoAluno.resumo_total?.psr_medio || '-' }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Gráfico de grupos musculares -->
            <div v-if="graficoSelecionado === 'grupos'">
              <div class="row justify-content-center">
                <div class="col-12 text-center">{{ $t('muscleGroups') }}</div>
              </div>
              <div class="row mt-4 justify-content-center">
                <div class="col-6">
                  <label class="form-label font-weight-bold">{{ $t('selectStudent') }}</label>
                  <select class="form-control form-control-sm" name="student-manager" required
                    id="select-student-manager" v-model="alunoSelecionadoGrupos" @change="setStudentManager">
                    <option value="" selected>{{ $t('selectHere') }}</option>
                    <option v-for="(item, index) in alunos" :key="index" :value="item.id">
                      {{ item.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="row mt-3 justify-content-center align-items-center">
                <!-- Período sempre visível -->
                <div class="col-auto">
                  <label class="form-label font-weight-bold">Período</label>
                  <select class="form-control form-control-sm" v-model="periodoSelecionadoGrupos"
                    @change="limparECarregarDados">
                    <option value="acumulado">Acumulado</option>
                    <option value="semana">Semana</option>
                    <option value="dia">Dia</option>
                    <option value="mes">Mês</option>
                    <option value="ano">Ano</option>
                  </select>
                </div>
                <!-- Semana: mostra só se for semana -->
                <div class="col-auto" v-if="periodoSelecionadoGrupos === 'semana'">
                  <label class="form-label font-weight-bold">Semana</label>
                  <select class="form-control form-control-sm" v-model="semanaSelecionadaGrupos"
                    @change="getDashboardDataGrupos">
                    <option value="">Selecione uma semana</option>
                    <option v-for="(week, index) in trainingPlanWeeks" :key="week.id" :value="week.id">
                      Semana {{ index + 1 }} ({{ formatDate(week.initial_date) }} - {{ formatDate(week.final_date) }})
                    </option>
                  </select>
                </div>
                <!-- Ano: mostra se não for acumulado, não for dia e não for semana -->
                <div class="col-auto"
                  v-if="periodoSelecionadoGrupos !== 'acumulado' && periodoSelecionadoGrupos !== 'dia' && periodoSelecionadoGrupos !== 'semana'">
                  <label class="form-label font-weight-bold">{{ $t('yearReference') }}</label>
                  <select class="form-control form-control-sm" v-model="anoSelecionadoGrupos"
                    @change="getDashboardDataGrupos">
                    <option value="2023">2023</option>
                    <option value="2024">2024</option>
                    <option value="2025">2025</option>
                    <option value="2026">2026</option>
                    <option value="2027">2027</option>
                    <option value="2028">2028</option>
                    <option value="2029">2029</option>
                    <option value="2030">2030</option>
                  </select>
                </div>
                <!-- Mês: mostra se for mês mas não dia -->
                <div class="col-auto" v-if="['mes'].includes(periodoSelecionadoGrupos)">
                  <label class="form-label font-weight-bold">{{ $t('monthReference') }}</label>
                  <select class="form-control form-control-sm" v-model="mesSelecionadoGrupos"
                    @change="getDashboardDataGrupos">
                    <option v-for="(item, index) in stats.months" :key="index" :value="item.numero">
                      {{ $t(item.mes) }}
                    </option>
                  </select>
                </div>
                <!-- Dia: mostra só se for dia -->
                <div class="col-auto" v-if="periodoSelecionadoGrupos === 'dia'">
                  <label class="form-label font-weight-bold">Dia</label>
                  <input type="date" class="form-control form-control-sm" v-model="diaSelecionadaGrupos"
                    @blur="getDashboardDataGrupos" />
                </div>
                <div class="col-auto">
                  <span>
                    <i class="fa fa-arrow-left" @click="voltarDataGrupos"></i>
                  </span>
                  <span>
                    <i class="fa fa-arrow-right" @click="avancarDataGrupos"></i>
                  </span>
                </div>
              </div>

              <div class="row mt-4">
                <div class="col-12">
                  <MuscleGroupsChart :studentId="alunoSelecionadoGrupos" :month="mesSelecionadoGrupos"
                    :year="anoSelecionadoGrupos" :period="periodoSelecionadoGrupos" :dia="diaSelecionadaGrupos"
                    :data="muscleGroupsData" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal de Preview do PDF -->
  <div v-if="showPreviewModal" class="modal-preview-overlay">
    <div class="modal-preview-content">
      <button class="close-btn" @click="fecharPreviewPDF">&times;</button>
      <h5 class="mb-3">{{ previewDocumentTitle || 'Pré-visualização do PDF' }}</h5>
      <div v-if="previewLoading" class="text-center my-4">
        <span class="spinner-border spinner-border-sm"></span> Gerando preview...
      </div>
      <div v-else>
        <div v-if="previewUrl" class="pdf-iframe-preview mb-4">
          <iframe :src="previewUrl" width="100%" height="900"
            style="min-width:600px; min-height:800px; border:1px solid #ccc; border-radius:8px; box-shadow:0 2px 8px #0001;"></iframe>
        </div>
        <div v-else class="text-center text-danger mb-4">
          Não foi possível gerar o preview do PDF.
        </div>
      </div>
      <div class="d-flex justify-content-center">
        <button type="button" class="btn btn-success" :disabled="statusEnvioRelatorio === 'enviando'"
          @click="enviarPDFdoPreview">
          <span v-if="statusEnvioRelatorio === 'enviando'" class="spinner-border spinner-border-sm me-2"></span>
          {{ previewMode === 'resumo' ? 'Enviar Resumo' : 'Enviar Completo' }}
        </button>
        <button type="button" class="btn btn-secondary ms-2" @click="fecharPreviewPDF">
          Cancelar
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import Card from '../../../components/Cards/Card.vue'
import ActiveUsersChart from '../../../components/Charts/ActiveUsersChart.vue'
import GradientLineChart from '../../../components/Charts/GradientLineChart.vue'
import MuscleGroupsChart from '../../../components/Charts/MuscleGroupsChart.vue'
import ResumoMesChart from '@/components/Charts/ResumoMesChart.vue'
import CaloricMonthChart from '@/components/Charts/CaloricMonthChart.vue'
import html2canvas from 'html2canvas'

import moment from 'moment/moment'
import dashboardRepository from '@/services/api/dashboardRepository'
import alunoRepository from '@/services/api/alunoRepository'
import avaliacaoFisicaRepository from '@/services/api/avaliacaoFisicaRepository'

import planosTreinoRepository from '../../../services/api/planosTreinoRepository'
import kpiRepository from '../../../services/api/kpiRepository'

export default {
  name: 'dashboard-default',

  async created() {
    console.log('dashboardItemEstimado', this.dashboardItemEstimado)
    this.listarAlunos()
    if (this.alunoSelecionado !== '' && this.alunoSelecionado !== null) {
      this.getDashboardData()
    }
    this.getIndicators()

    // Carregar semanas do plano de treino se já houver aluno selecionado
    const trainingPlanId = this.$store.state?.training_plan || this.$store.state?.trainingPlan
    if (trainingPlanId && this.alunoSelecionadoGrupos) {
      await this.fetchTrainingPlanWeeks(trainingPlanId)
    }
  },

  data() {
    return {
      mesSelecionado: moment().format('MM'),
      anoSelecionado: moment().format('YYYY'),
      alunoSelecionado: '',
      resumoAluno: {},
      resumoAlunoCaloric: null,
      statusEnvioRelatorio: '',
      showPreviewModal: false,
      previewUrl: '',
      previewLoading: false,
      previewMode: 'resumo', // 'resumo' ou 'completo'
      previewDocumentTitle: '',

      // ⚡ CORREÇÃO: Inicializar TODOS os valores dos grupos como vazios
      mesSelecionadoGrupos: '',
      anoSelecionadoGrupos: '',
      alunoSelecionadoGrupos: '',
      periodoSelecionadoGrupos: 'acumulado', // Começar com acumulado para não precisar de valores
      diaSelecionadaGrupos: '',
      semanaSelecionadaGrupos: '',
      trainingPlanWeeks: [],
      muscleGroupsData: null,

      alunos: [],
      stats: {
        months: [
          { mes: 'january', numero: '01' },
          { mes: 'february', numero: '02' },
          { mes: 'march', numero: '03' },
          { mes: 'april', numero: '04' },
          { mes: 'may', numero: '05' },
          { mes: 'june', numero: '06' },
          { mes: 'july', numero: '07' },
          { mes: 'august', numero: '08' },
          { mes: 'september', numero: '09' },
          { mes: 'october', numero: '10' },
          { mes: 'november', numero: '11' },
          { mes: 'december', numero: '12' },
        ],
        dataFiltro: moment().format('YYYY-MM'),
        iconBackground: 'bg-gradient-success',
      },

      dashboardItemEstimado: null,
      dashboardItem: null,
      indicators: [],
      graficoSelecionado: 'evolucao',

      // Aniversariantes
      aniversariantesDia: [],
      aniversariantesMes: [],
      mostrarTodosAniversariantes: false,
    }
  },

  watch: {
    // Watchers para aba Evolução
    mesSelecionado(novoMes) {
      if (this.alunoSelecionado) {
        this.buscarResumoAlunoEvolucao()
      }
    },
    anoSelecionado(novoAno) {
      if (this.alunoSelecionado) {
        this.buscarResumoAlunoEvolucao()
      }
    },

    // Watchers para aba Grupos Musculares
    async periodoSelecionadoGrupos(novoPeriodo, periodoAnterior) {
      console.log('Watch: Período mudou de', periodoAnterior, 'para', novoPeriodo)

      // LIMPAR TUDO primeiro
      this.diaSelecionadaGrupos = ''
      this.semanaSelecionadaGrupos = ''

      // Resetar para valores padrão baseado no período
      if (novoPeriodo === 'semana') {
        // Garantir que as semanas estejam carregadas
        const trainingPlanId = this.$store.state?.training_plan || this.$store.state?.trainingPlan
        if (trainingPlanId && this.trainingPlanWeeks.length === 0) {
          console.log('⏳ Watch: Carregando semanas do plano de treino...')
          await this.fetchTrainingPlanWeeks(trainingPlanId)
        }

        // Se tiver semanas disponíveis, seleciona a primeira
        if (this.trainingPlanWeeks.length > 0) {
          this.semanaSelecionadaGrupos = this.trainingPlanWeeks[0].id
          console.log('✅ Watch: Primeira semana selecionada:', this.semanaSelecionadaGrupos)
        }
      } else if (novoPeriodo === 'mes') {
        this.mesSelecionadoGrupos = moment().format('MM')
        this.anoSelecionadoGrupos = moment().format('YYYY')
      } else if (novoPeriodo === 'ano') {
        this.anoSelecionadoGrupos = moment().format('YYYY')
      } else if (novoPeriodo === 'acumulado') {
        // Para acumulado, manter valores vazios ou padrão
        this.mesSelecionadoGrupos = moment().format('MM')
        this.anoSelecionadoGrupos = moment().format('YYYY')
      }
      if (novoPeriodo === 'mes') {
        this.buscarResumoAluno()
      }
      console.log('Watch: Após limpeza - dia:', this.diaSelecionadaGrupos, 'semana:', this.semanaSelecionadaGrupos, 'mes:', this.mesSelecionadoGrupos, 'ano:', this.anoSelecionadoGrupos)

      // Não chamar getDashboardDataGrupos aqui para evitar loop
    },
    alunoSelecionadoGrupos(novoPeriodo) {
      if (this.periodoSelecionadoGrupos === 'mes') {
        this.buscarResumoAluno()
      }
    },
    mesSelecionadoGrupos(novo) {
      if (this.periodoSelecionadoGrupos === 'mes') {
        this.buscarResumoAluno()
      }
    },
    anoSelecionadoGrupos(novo) {
      if (this.periodoSelecionadoGrupos === 'mes') {
        this.buscarResumoAluno()
      }
    }
  },

  methods: {
    async buscarResumoAlunoEvolucao() {
      if (!this.alunoSelecionado) {
        console.warn('Nenhum aluno selecionado na aba Evolução')
        this.resumoAluno = {}
        this.resumoAlunoCaloric = null
        return
      }

      // Buscar resumo total de treinos
      let resumo = null
      try {
        const trainingPlanId = this.$store.state?.training_plan || this.$store.state?.trainingPlan
        const headers = {
          'student-manager': this.alunoSelecionado
        }
        if (trainingPlanId) {
          headers['training-plan-manager'] = trainingPlanId
        }

        const res = await kpiRepository.TrainingResumeGet({
          headers: headers
        })
        if (res.data.success) {
          resumo = res.data.data

          if (
            this.mesSelecionado &&
            this.anoSelecionado &&
            resumo.detalhes_por_mes
          ) {
            const key = `${this.anoSelecionado}-${String(this.mesSelecionado).padStart(2, '0')}`
            const detalhes = resumo.detalhes_por_mes[key]
            this.resumoAluno = {
              ...resumo,
              detalhes_mes: detalhes || null
            }
          } else {
            this.resumoAluno = resumo
          }
        }
      } catch (error) {
        console.error('Erro ao buscar resumo de treinos (Evolução):', error)
        this.resumoAluno = {}
      }

      // Buscar gasto calórico do mês
      this.resumoAlunoCaloric = null
      if (this.mesSelecionado && this.anoSelecionado) {
        try {
          const trainingPlanId = this.$store.state?.training_plan || this.$store.state?.trainingPlan
          const headers = {
            'student-manager': this.alunoSelecionado
          }
          if (trainingPlanId) {
            headers['training-plan-manager'] = trainingPlanId
          }

          const resCal = await kpiRepository.CaloricExpenditureByMonthGet(
            this.anoSelecionado,
            this.mesSelecionado,
            {
              headers: headers
            }
          )
          if (resCal.data.success) {
            this.resumoAlunoCaloric = resCal.data.data
            console.log('✅ Gasto calórico do mês obtido (Evolução):', this.resumoAlunoCaloric)
          }
        } catch (error) {
          console.error('❌ Erro ao buscar gasto calórico do mês (Evolução):', error)
        }
      }
    },

    async buscarResumoAluno() {
      if (!this.alunoSelecionadoGrupos) {
        console.warn('Nenhum aluno selecionado')
        this.resumoAluno = {}
        this.resumoAlunoCaloric = null
        return
      }
      // Buscar resumo total de treinos
      let resumo = null
      try {
        const res = await kpiRepository.TrainingResumeGet()
        if (res.data.success) {
          resumo = res.data.data

          if (
            this.periodoSelecionadoGrupos === 'mes' &&
            this.mesSelecionadoGrupos &&
            this.anoSelecionadoGrupos &&
            resumo.detalhes_por_mes
          ) {
            const key = `${this.anoSelecionadoGrupos}-${String(this.mesSelecionadoGrupos).padStart(2, '0')}`
            const detalhes = resumo.detalhes_por_mes[key]
            this.resumoAluno = {
              ...resumo,
              detalhes_mes: detalhes || null
            }
          } else {
            this.resumoAluno = resumo
          }
        }
      } catch (error) {
        console.error('Erro ao buscar resumo de treinos:', error)
        this.resumoAluno = {}
      }

      // Buscar gasto calórico do mês
      this.resumoAlunoCaloric = null
      if (
        this.periodoSelecionadoGrupos === 'mes' &&
        this.mesSelecionadoGrupos &&
        this.anoSelecionadoGrupos
      ) {
        try {
          const resCal = await kpiRepository.CaloricExpenditureByMonthGet(
            this.anoSelecionadoGrupos,
            this.mesSelecionadoGrupos
          )
          if (resCal.data.success) {
            this.resumoAlunoCaloric = resCal.data.data
            console.log('✅ Gasto calórico do mês obtido:', this.resumoAlunoCaloric)
          }
        } catch (error) {
          console.error('❌ Erro ao buscar gasto calórico do mês:', error)
        }
      }
    },
    listarAlunos() {
      alunoRepository.AlunoGet()
        .then((response) => {
          this.alunos = []
          if (response.data.success) {
            this.alunos = response.data.data
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },

    async limparECarregarDados() {
      console.log('=== MÉTODO LIMPAR E CARREGAR ===')
      console.log('Período atual:', this.periodoSelecionadoGrupos)

      // LIMPAR TUDO primeiro
      this.diaSelecionadaGrupos = ''
      this.mesSelecionadoGrupos = ''
      this.anoSelecionadoGrupos = ''
      this.semanaSelecionadaGrupos = ''

      // Definir valores apenas para os campos necessários do período
      if (this.periodoSelecionadoGrupos === 'mes') {
        this.mesSelecionadoGrupos = moment().format('MM')
        this.anoSelecionadoGrupos = moment().format('YYYY')
      } else if (this.periodoSelecionadoGrupos === 'ano') {
        this.anoSelecionadoGrupos = moment().format('YYYY')
      } else if (this.periodoSelecionadoGrupos === 'semana') {
        // Garantir que as semanas estejam carregadas
        const trainingPlanId = this.$store.state?.training_plan || this.$store.state?.trainingPlan
        if (trainingPlanId && this.trainingPlanWeeks.length === 0) {
          console.log('⏳ Carregando semanas do plano de treino...')
          await this.fetchTrainingPlanWeeks(trainingPlanId)
        }

        // Se tiver semanas disponíveis, seleciona a primeira
        if (this.trainingPlanWeeks.length > 0) {
          this.semanaSelecionadaGrupos = this.trainingPlanWeeks[0].id
          console.log('✅ Primeira semana selecionada:', this.semanaSelecionadaGrupos)
        } else {
          console.warn('⚠️ Nenhuma semana disponível para selecionar')
        }
      }
      // Para 'dia' e 'acumulado' deixar tudo vazio

      console.log('Valores após limpeza e definição:')
      console.log('- diaSelecionadaGrupos:', this.diaSelecionadaGrupos)
      console.log('- semanaSelecionadaGrupos:', this.semanaSelecionadaGrupos)
      console.log('- mesSelecionadoGrupos:', this.mesSelecionadoGrupos)
      console.log('- anoSelecionadoGrupos:', this.anoSelecionadoGrupos)
      console.log('================================')

      this.$nextTick(() => {
        this.getDashboardDataGrupos()
      })
    },

    avancarData() {
      this.stats.dataFiltro = moment(this.stats.dataFiltro).add(1, 'M').format('YYYY-MM')
      const [ano, mes] = this.stats.dataFiltro.split('-')
      this.mesSelecionado = mes
      this.anoSelecionado = ano
      this.getDashboardData()
    },

    voltarData() {
      this.stats.dataFiltro = moment(this.stats.dataFiltro).subtract(1, 'M').format('YYYY-MM')
      const [ano, mes] = this.stats.dataFiltro.split('-')
      this.mesSelecionado = mes
      this.anoSelecionado = ano
      this.getDashboardData()
    },

    avancarDataGrupos() {
      this.stats.dataFiltroGrupos = moment(`${this.anoSelecionadoGrupos}-${this.mesSelecionadoGrupos}`)
        .add(1, 'M').format('YYYY-MM')
      const [ano, mes] = this.stats.dataFiltroGrupos.split('-')
      this.mesSelecionadoGrupos = mes
      this.anoSelecionadoGrupos = ano
      this.getDashboardDataGrupos()
    },

    voltarDataGrupos() {
      this.stats.dataFiltroGrupos = moment(`${this.anoSelecionadoGrupos}-${this.mesSelecionadoGrupos}`)
        .subtract(1, 'M').format('YYYY-MM')
      const [ano, mes] = this.stats.dataFiltroGrupos.split('-')
      this.mesSelecionadoGrupos = mes
      this.anoSelecionadoGrupos = ano
      this.getDashboardDataGrupos()
    },

    getIndicators() {
      dashboardRepository.DashboardIndicatorsGet()
        .then((response) => {
          if (response.data.success) {
            this.indicators = response.data.data
          }
        })
        .catch((error) => console.error(error))

      // Buscar aniversariantes ao carregar indicators
      this.buscarAniversariantes()
    },

    async buscarAniversariantes() {
      try {
        const hoje = new Date()
        const mes = hoje.getMonth() + 1
        const ano = hoje.getFullYear()
        const diaHoje = hoje.getDate()

        const response = await dashboardRepository.AniversariantesDoMesGet(mes, ano)

        if (response.data.success) {
          const todos = response.data.data.aniversariantes || []

          // Filtrar aniversariantes do dia
          this.aniversariantesDia = todos.filter(a => parseInt(a.dia_aniversario) === diaHoje)

          // Todos os outros aniversariantes do mês
          this.aniversariantesMes = todos.filter(a => parseInt(a.dia_aniversario) !== diaHoje)
        }
      } catch (error) {
        console.error('Erro ao buscar aniversariantes:', error)
      }
    },

    toggleAniversariantes() {
      this.mostrarTodosAniversariantes = !this.mostrarTodosAniversariantes
    },

    getMesNomeAtual() {
      const meses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
        'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']
      return meses[new Date().getMonth()]
    },

    getMesNumero() {
      return String(new Date().getMonth() + 1).padStart(2, '0')
    },

    getDashboardData() {
      const item = {
        student_id: this.alunoSelecionado,
        year: this.anoSelecionado,
        month: this.mesSelecionado,
      }

      dashboardRepository.DashboardPreviewPost(item)
        .then((response) => {
          if (response.data.success) {
            this.dashboardItemEstimado = response.data.data
          }
        })
        .catch((error) => console.error(error))

      dashboardRepository.DashboardRealizesPost(item)
        .then((response) => {
          if (response.data.success) {
            this.dashboardItem = response.data.data
          }
        })
        .catch((error) => console.error(error))
    },

    getMuscleGroupReport() {
      // Mapeia para os valores esperados pela API
      const periodMap = {
        'dia': 'day',
        'semana': 'week',
        'mes': 'month',
        'ano': 'year',
        'acumulado': 'accumulated'
      }
      const periodApi = periodMap[this.periodoSelecionadoGrupos] || this.periodoSelecionadoGrupos

      const params = {
        period: periodApi,
      }

      if (periodApi === 'week') {
        if (!this.semanaSelecionadaGrupos) {
          console.warn('⚠️ Período é semana mas nenhuma semana foi selecionada!')
          return
        }
        params.week_id = this.semanaSelecionadaGrupos
        console.log('📅 PERÍODO SEMANA - week_id:', this.semanaSelecionadaGrupos)
      } else if (periodApi === 'day') {
        params.date = this.diaSelecionadaGrupos
      } else if (periodApi === 'month') {
        params.month = Number(this.mesSelecionadoGrupos)
        params.year = this.anoSelecionadoGrupos
      } else if (periodApi === 'year') {
        params.year = this.anoSelecionadoGrupos
      }

      console.log('📊 Params para API (getMuscleGroupReport):', params)
      console.log('👤 Student ID:', this.alunoSelecionadoGrupos)

      // Corrigido: passar params e headers separadamente
      avaliacaoFisicaRepository.MuscleGroupReport(
        {
          params: params,
          headers: {
            'student-manager': this.alunoSelecionadoGrupos,
          }
        }
      )
        .then((response) => {
          if (response.data.success) {
            console.log('✅ Resposta da API MuscleGroupReport:', response.data.data)
            this.muscleGroupsData = response.data.data
          }
        })
        .catch((error) => console.error('❌ Erro ao carregar MuscleGroupReport:', error))
    },

    getDashboardDataGrupos() {
      console.log('=== ENVIANDO PARA COMPONENTE ===')
      console.log('periodoSelecionadoGrupos:', this.periodoSelecionadoGrupos)
      console.log('diaSelecionadaGrupos:', this.diaSelecionadaGrupos)
      console.log('semanaSelecionadaGrupos:', this.semanaSelecionadaGrupos)
      console.log('mesSelecionadoGrupos:', this.mesSelecionadoGrupos)
      console.log('anoSelecionadoGrupos:', this.anoSelecionadoGrupos)
      console.log('================================')

      this.getMuscleGroupReport()
    },

    async setStudentManager() {
      const id = parseInt(this.alunoSelecionadoGrupos)
      this.$store.commit('SET_STUDENT', id > 0 ? id : null)

      // Buscar o plano de treino ativo do aluno
      if (id > 0) {
        try {
          // Usar o método PlanosTreinoGet com header do aluno
          const response = await planosTreinoRepository.PlanosTreinoGet({
            headers: {
              'student-manager': id
            }
          })

          if (response.data.success && response.data.data) {
            const planos = Array.isArray(response.data.data) ? response.data.data : [response.data.data]

            // Procurar o plano ativo
            const planoAtivo = planos.find(p => p.active === 1 || p.active === true || p.status === 'active')

            if (planoAtivo) {
              this.$store.commit('SET_TRAINING_PLAN', planoAtivo.id)
              console.log('Plano de treino definido:', planoAtivo.id)
              // Buscar semanas do plano de treino
              await this.fetchTrainingPlanWeeks(planoAtivo.id)
            } else {
              // Se não encontrar ativo, pega o primeiro
              if (planos.length > 0) {
                this.$store.commit('SET_TRAINING_PLAN', planos[0].id)
                console.log('Usando primeiro plano encontrado:', planos[0].id)
                // Buscar semanas do plano de treino
                await this.fetchTrainingPlanWeeks(planos[0].id)
              } else {
                this.$store.commit('SET_TRAINING_PLAN', null)
                console.warn('Nenhum plano de treino encontrado para o aluno')
              }
            }
          } else {
            this.$store.commit('SET_TRAINING_PLAN', null)
            console.warn('Nenhum plano de treino retornado pela API')
          }
        } catch (error) {
          console.error('Erro ao buscar plano de treino:', error)
          this.$store.commit('SET_TRAINING_PLAN', null)
        }
      } else {
        this.$store.commit('SET_TRAINING_PLAN', null)
      }

      // Aguardar um momento para o store ser atualizado
      await this.$nextTick()

      // Recarrega os dados do relatório
      this.getDashboardDataGrupos()
    },

    async setStudentManagerEvolucao() {
      const id = parseInt(this.alunoSelecionado)
      this.$store.commit('SET_STUDENT', id > 0 ? id : null)

      // Buscar o plano de treino ativo do aluno
      if (id > 0) {
        try {
          // Usar o método PlanosTreinoGet com header do aluno
          const response = await planosTreinoRepository.PlanosTreinoGet({
            headers: {
              'student-manager': id
            }
          })

          if (response.data.success && response.data.data) {
            const planos = Array.isArray(response.data.data) ? response.data.data : [response.data.data]

            // Procurar o plano ativo
            const planoAtivo = planos.find(p => p.active === 1 || p.active === true || p.status === 'active')

            if (planoAtivo) {
              this.$store.commit('SET_TRAINING_PLAN', planoAtivo.id)
              console.log('Plano de treino definido (Evolução):', planoAtivo.id)
            } else {
              // Se não encontrar ativo, pega o primeiro
              if (planos.length > 0) {
                this.$store.commit('SET_TRAINING_PLAN', planos[0].id)
                console.log('Usando primeiro plano encontrado (Evolução):', planos[0].id)
              } else {
                this.$store.commit('SET_TRAINING_PLAN', null)
                console.warn('Nenhum plano de treino encontrado para o aluno')
              }
            }
          } else {
            this.$store.commit('SET_TRAINING_PLAN', null)
            console.warn('Nenhum plano de treino retornado pela API')
          }
        } catch (error) {
          console.error('Erro ao buscar plano de treino:', error)
          this.$store.commit('SET_TRAINING_PLAN', null)
        }
      } else {
        this.$store.commit('SET_TRAINING_PLAN', null)
      }

      // Aguardar um momento para o store ser atualizado
      await this.$nextTick()

      // Recarrega os dados da aba Evolução
      this.getDashboardData()
      this.buscarResumoAlunoEvolucao()
    },

    async fetchTrainingPlanWeeks(trainingPlanId) {
      try {
        const response = await planosTreinoRepository.SemanasGetByPlanosTreinoId(trainingPlanId)
        if (response.data.success && response.data.data) {
          this.trainingPlanWeeks = response.data.data
          console.log('Semanas do plano de treino carregadas:', this.trainingPlanWeeks)
        } else {
          this.trainingPlanWeeks = []
        }
      } catch (error) {
        console.error('Erro ao buscar semanas do plano de treino:', error)
        this.trainingPlanWeeks = []
      }
    },

    formatDate(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString + 'T00:00:00') // Force local timezone
      const day = String(date.getDate()).padStart(2, '0')
      const month = String(date.getMonth() + 1).padStart(2, '0')
      return `${day}/${month}`
    },

    getMesNome(mes) {
      const meses = {
        '1': 'Janeiro', '2': 'Fevereiro', '3': 'Março',
        '4': 'Abril', '5': 'Maio', '6': 'Junho',
        '7': 'Julho', '8': 'Agosto', '9': 'Setembro',
        '10': 'Outubro', '11': 'Novembro', '12': 'Dezembro',
        '01': 'Janeiro', '02': 'Fevereiro', '03': 'Março',
        '04': 'Abril', '05': 'Maio', '06': 'Junho',
        '07': 'Julho', '08': 'Agosto', '09': 'Setembro'
      }
      return meses[mes] || mes
    },

    // Capturar gráficos de resumo com dados textuais como base64
    async capturarGraficosResumo(incluirTabelaEvolucao = false) {
      try {
        const graficos = []

        // Aguardar renderização
        await this.$nextTick()
        await new Promise(r => setTimeout(r, 500))

        // 1. Capturar a tabela de comparação de evolução (PRIMEIRO) - APENAS se for relatório completo
        if (incluirTabelaEvolucao) {
          const tabelaEvolucao = document.getElementById('tabela-comparacao-evolucao')
          if (tabelaEvolucao) {
            const canvasTabela = await html2canvas(tabelaEvolucao, {
              scale: 2,
              useCORS: true,
              backgroundColor: '#ffffff',
              logging: false
            })
            graficos.push(canvasTabela.toDataURL('image/png'))
          }
        }

        // 2. Capturar o container completo com AMBOS os gráficos e dados textuais (SEGUNDO)
        const containerCompleto = document.getElementById('graficos-resumo-completo')
        if (containerCompleto) {
          const canvas = await html2canvas(containerCompleto, {
            scale: 2,
            useCORS: true,
            backgroundColor: '#ffffff',
            logging: false
          })
          graficos.push(canvas.toDataURL('image/png'))
        }

        return graficos
      } catch (error) {
        console.error('Erro ao capturar gráficos:', error)
        return []
      }
    },

    // Preview apenas do Resumo
    async previewResumo() {
      if (!this.alunoSelecionado || !this.mesSelecionado || !this.anoSelecionado) {
        this.$toast.error('Selecione um aluno, mês e ano para visualizar o relatório')
        return
      }

      if (!this.resumoAluno) {
        this.$toast.error('Dados do resumo não carregados. Aguarde um momento.')
        return
      }

      this.previewMode = 'resumo'
      this.showPreviewModal = true
      this.previewUrl = ''
      this.previewLoading = true
      this.previewDocumentTitle = 'Pré-visualização do Resumo Mensal'

      try {
        // Capturar os gráficos de resumo (sem tabela de evolução)
        const graficos = await this.capturarGraficosResumo(false)

        const payload = {
          graficos: graficos, // Gráficos capturados
          dados: [], // Apenas resumo, sem dados de grupos musculares
          resumo_mes: this.resumoAluno,
          mes: this.mesSelecionado,
          ano: this.anoSelecionado
        }

        const response = await avaliacaoFisicaRepository.PreviewPdf(payload, {
          headers: {
            'student-manager': this.alunoSelecionado
          }
        })

        if (response.data.success && response.data.preview_url) {
          this.previewUrl = response.data.preview_url
        } else {
          this.$toast.error('Erro ao gerar preview')
          this.showPreviewModal = false
        }
      } catch (error) {
        console.error('Erro ao gerar preview:', error)
        this.$toast.error('Erro ao gerar preview. Tente novamente.')
        this.showPreviewModal = false
      } finally {
        this.previewLoading = false
      }
    },

    // Enviar apenas o Resumo
    async enviarRelatorioResumo() {
      if (!this.alunoSelecionado || !this.mesSelecionado || !this.anoSelecionado) {
        this.$toast.error('Selecione um aluno, mês e ano para enviar o relatório')
        return
      }

      if (!this.resumoAluno) {
        this.$toast.error('Dados do resumo não carregados. Aguarde um momento.')
        return
      }

      this.statusEnvioRelatorio = 'enviando'

      try {
        // Capturar os gráficos de resumo (sem tabela de evolução)
        const graficos = await this.capturarGraficosResumo(false)

        const payload = {
          graficos: graficos, // Gráficos capturados
          dados: [], // Apenas resumo, sem dados de grupos musculares
          resumo_mes: this.resumoAluno,
          mes: this.mesSelecionado,
          ano: this.anoSelecionado
        }

        const response = await avaliacaoFisicaRepository.MuscleGroupReportPDF(payload, {
          headers: {
            'student-manager': this.alunoSelecionado
          }
        })

        if (response.data.success) {
          this.$toast.success(response.data.message || 'Relatório de resumo enviado com sucesso!')
        } else {
          this.$toast.error(response.data.message || 'Erro ao enviar relatório')
        }
      } catch (error) {
        console.error('Erro ao enviar relatório:', error)
        this.$toast.error('Erro ao enviar relatório. Tente novamente.')
      } finally {
        this.statusEnvioRelatorio = ''
      }
    },

    // Preview do Relatório Completo (Evolução + Resumo)
    async previewCompleto() {
      if (!this.alunoSelecionado || !this.mesSelecionado || !this.anoSelecionado) {
        this.$toast.error('Selecione um aluno, mês e ano para visualizar o relatório')
        return
      }

      if (!this.resumoAluno || !this.dashboardItem) {
        this.$toast.error('Dados não carregados. Aguarde um momento.')
        return
      }

      this.previewMode = 'completo'
      this.showPreviewModal = true
      this.previewUrl = ''
      this.previewLoading = true
      this.previewDocumentTitle = 'Pré-visualização do Relatório Completo'

      try {
        // Capturar os gráficos de resumo COM tabela de evolução
        const graficos = await this.capturarGraficosResumo(true)

        const payload = {
          graficos: graficos, // Gráficos capturados
          dados: [], // Dados da tabela de evolução já estão no backend
          resumo_mes: this.resumoAluno,
          mes: this.mesSelecionado,
          ano: this.anoSelecionado,
          dashboard_data: this.dashboardItem // Dados da evolução
        }

        const response = await avaliacaoFisicaRepository.PreviewPdf(payload, {
          headers: {
            'student-manager': this.alunoSelecionado
          }
        })

        if (response.data.success && response.data.preview_url) {
          this.previewUrl = response.data.preview_url
        } else {
          this.$toast.error('Erro ao gerar preview')
          this.showPreviewModal = false
        }
      } catch (error) {
        console.error('Erro ao gerar preview completo:', error)
        this.$toast.error('Erro ao gerar preview. Tente novamente.')
        this.showPreviewModal = false
      } finally {
        this.previewLoading = false
      }
    },

    // Fechar modal de preview
    fecharPreviewPDF() {
      this.showPreviewModal = false
      this.previewUrl = ''
      this.previewLoading = false
    },

    // Enviar PDF do preview
    async enviarPDFdoPreview() {
      if (this.previewMode === 'resumo') {
        await this.enviarRelatorioResumo()
      } else {
        await this.enviarRelatorioCompleto()
      }
      this.fecharPreviewPDF()
    },

    // Enviar Relatório Completo (Evolução + Resumo)
    async enviarRelatorioCompleto() {
      if (!this.alunoSelecionado || !this.mesSelecionado || !this.anoSelecionado) {
        this.$toast.error('Selecione um aluno, mês e ano para enviar o relatório')
        return
      }

      if (!this.resumoAluno || !this.dashboardItem) {
        this.$toast.error('Dados não carregados. Aguarde um momento.')
        return
      }

      this.statusEnvioRelatorio = 'enviando'

      try {
        // Capturar os gráficos de resumo COM tabela de evolução
        const graficos = await this.capturarGraficosResumo(true)

        const payload = {
          graficos: graficos, // Gráficos capturados
          dados: [], // Dados da tabela de evolução já estão no backend
          resumo_mes: this.resumoAluno,
          mes: this.mesSelecionado,
          ano: this.anoSelecionado,
          dashboard_data: this.dashboardItem // Dados da evolução
        }

        const response = await avaliacaoFisicaRepository.MuscleGroupReportPDF(payload, {
          headers: {
            'student-manager': this.alunoSelecionado
          }
        })

        if (response.data.success) {
          this.$toast.success(response.data.message || 'Relatório completo enviado com sucesso!')
        } else {
          this.$toast.error(response.data.message || 'Erro ao enviar relatório')
        }
      } catch (error) {
        console.error('Erro ao enviar relatório completo:', error)
        this.$toast.error('Erro ao enviar relatório. Tente novamente.')
      } finally {
        this.statusEnvioRelatorio = ''
      }
    },

    async enviarRelatorioMensalGrupos() {
      if (!this.alunoSelecionadoGrupos || !this.mesSelecionadoGrupos || !this.anoSelecionadoGrupos) {
        this.$toast.error('Selecione um aluno, mês e ano para enviar o relatório')
        return
      }

      if (!this.resumoAluno) {
        this.$toast.error('Dados do resumo não carregados. Aguarde um momento.')
        return
      }

      this.statusEnvioRelatorio = 'enviando'

      try {
        const payload = {
          graficos: [], // Apenas resumo, sem gráficos
          dados: [], // Apenas resumo, sem dados de grupos musculares
          resumo_mes: this.resumoAluno,
          mes: this.mesSelecionadoGrupos,
          ano: this.anoSelecionadoGrupos
        }

        const response = await avaliacaoFisicaRepository.MuscleGroupReportPDF(payload)

        if (response.data.success) {
          this.$toast.success(response.data.message || 'Relatório de resumo mensal enviado com sucesso!')
        } else {
          this.$toast.error(response.data.message || 'Erro ao enviar relatório')
        }
      } catch (error) {
        console.error('Erro ao enviar relatório:', error)
        this.$toast.error('Erro ao enviar relatório. Tente novamente.')
      } finally {
        this.statusEnvioRelatorio = ''
      }
    }
  },

  components: {
    Card,
    ActiveUsersChart,
    GradientLineChart,
    MuscleGroupsChart,
    ResumoMesChart,
    CaloricMonthChart,
  }
}
</script>

<style scoped>
.month-indicator {
  color: #3498db;
  font-weight: 700;
}

/* Card de Aniversariantes */
.border-bottom:last-child {
  border-bottom: none !important;
}

/* Modal de Preview */
.modal-preview-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  overflow-y: auto;
  padding: 20px;
}

.modal-preview-content {
  background: white;
  border-radius: 10px;
  padding: 32px 24px 24px 24px;
  min-width: 60vw;
  max-width: 98vw;
  max-height: 98vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}

.close-btn {
  position: absolute;
  top: 15px;
  right: 20px;
  background: #dc3545;
  color: white;
  border: none;
  font-size: 24px;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  transition: background-color 0.3s;
}

.close-btn:hover {
  background: #c82333;
}

.pdf-iframe-preview iframe {
  display: block;
  margin: 0 auto;
}

/* Animação para lista de aniversariantes */
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Hover effect para a seta de expansão */
.cursor-pointer:hover {
  color: #007bff !important;
}

.cursor-pointer:hover i {
  color: #007bff !important;
}

/* Remove última borda da lista */
.border-bottom:last-child {
  border-bottom: none !important;
}
</style>